/* Built In Imports */
import { createRef } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import ReCAPTCHA from 'react-google-recaptcha';

/* Internal Imports */
/* Style */
/* Services */
/* Components */

/**
 * Renders Re captcha Component
 * @param {Object} props
 * @param {string} sitekey
 * @returns {ReactElement} Re-captcha Component
 */
export const Recaptcha = ({ props, sitekey }) => {
  const recaptchaRef = createRef();

  // useEffect(() => {
  //   // consoleLog('props.recaptcha');
  //   recaptchaRef.current.reset();
  // }, [props.recaptcha]);

  return (
    <Box display="flex" placeContent="center">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={sitekey}
        onChange={success => {
          success === null
            ? recaptchaRef.current.reset()
            : props.setFieldValue('recaptcha', success);
        }}
        onErrored={error => {
          props.setFieldValue('recaptcha', '');
          recaptchaRef.current.reset();
        }}
      />
    </Box>
  );
};

export default Recaptcha;
